import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QueryKeys } from '../keys';
import { request } from '../request';

export const useRefreshPeppol = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return request('/user/refresh-peppol', { method: 'POST' });
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: QueryKeys.user });
    },
  });
};
